<template>
  <span v-bind="$attrs" :class="computedClass">
    <slot></slot>
  </span>
</template>

<script>
export default {
  name: 'Chip',
  props: {
    color: {
      default: 'primary',
      validator(value) {
        return ['primary', 'secondary', 'tertiary'].includes(value);
      },
    },
    bold: Boolean,
    rounded: Boolean,
  },
  computed: {
    computedClass() {
      const classList = ['chip', this.color];

      if (this.bold) classList.push('bold');
      if (this.rounded) classList.push('rounded');

      return classList;
    }
  }
};
</script>

<style lang="scss" scoped>
.chip {
  padding: 1px 7px;
  height: 1.5rem;
  line-height: 1.5rem;
  display: flex;
  align-items: baseline;

  &.rounded {
    border-radius: .5rem;
  }

  &.bold {
    font-weight: 600;
  }
}

.primary {
  background-color: $primary-color-pale;
  color: $primary-color;
}
.secondary {
  background-color: $secondary-color-pale;
  color: $secondary-color;
}
.tertiary {
  background-color: $tertiary-color-pale;
  color: $tertiary-color;
}

</style>
